import React, { useState, useEffect } from "react";
import New_C_Footer_2025_V2 from "../components/footer_automatic_files/Layout";
import New_C_Header_2025_V2 from "../components/header_automatic_files/Header";


import New_C_Detail_Formation_Automatic_Files from "../components/detail_formation_automatic_files/new_detail_formation_2025"
import New_Navigation_2025 from "../components/New_Navigation_2025";



const new_p_detail_formation_2025 = () => {


  return (
    <div>
      <New_Navigation_2025 />
      <New_C_Header_2025_V2 />

      <New_C_Detail_Formation_Automatic_Files />

      <New_C_Footer_2025_V2 />

    </div>

  )
}


export default new_p_detail_formation_2025;
